module.exports = __webpack_public_path__ + "media/images/img_service_3-c3da967df3b410118d215b21cc1c7640.png";